export type ItemsRouteState = { mode: "list" } | { mode: "create" } | { mode: "detail"; itemId: string };

const ITEMS_BASE_PATH = "/fulfill/product/items";

export const CREATE_ITEM_ROUTE_SEGMENT = "new";

export const ITEM_TAB_QUERY_PARAM = "tab";

export const PRODUCTION_ITEMS_TAB_PARAM = "production";

export const ITEM_COMBINE_WITH_QUERY_PARAM = "combineWith";

export const buildItemsRoute = (state: ItemsRouteState): string => {
	if (state.mode === "list") return ITEMS_BASE_PATH;
	if (state.mode === "create") return `${ITEMS_BASE_PATH}/${CREATE_ITEM_ROUTE_SEGMENT}`;
	return `${ITEMS_BASE_PATH}/${state.itemId}`;
};

export const buildItemProductionTabRoute = (itemId: string): string =>
	`${buildItemsRoute({ itemId, mode: "detail" })}?${ITEM_TAB_QUERY_PARAM}=${PRODUCTION_ITEMS_TAB_PARAM}`;

export const buildItemCombineRoute = (survivorId: string, loserId: string): string =>
	`${buildItemsRoute({ itemId: survivorId, mode: "detail" })}?${ITEM_COMBINE_WITH_QUERY_PARAM}=${encodeURIComponent(loserId)}`;

export const requestsProductionTab = (tabParam: string | null): boolean => tabParam === PRODUCTION_ITEMS_TAB_PARAM;

export const isItemsRoute = (pathname: string): boolean =>
	pathname === ITEMS_BASE_PATH || pathname.startsWith(`${ITEMS_BASE_PATH}/`);

const parseItemsRoute = (param: string | undefined): ItemsRouteState => {
	if (param === undefined) return { mode: "list" };
	const trimmed = param.trim();
	if (trimmed.length === 0) return { mode: "list" };
	if (param === CREATE_ITEM_ROUTE_SEGMENT) return { mode: "create" };
	return { mode: "detail", itemId: param };
};

export default parseItemsRoute;
